export default __webpack_public_path__ + "static/logo-tecalis-square-dfe66df5fa81644699e3c8b2668a49ed.jpg";